import React from 'react';
import { facts1980s } from '../data/facts1980s.js';
import { facts1990s } from '../data/facts1990s.js';
import { facts2000s } from '../data/facts2000s.js';
import { documents2010s } from '../data/documents2010s.js';
import { documents2020s } from '../data/documents2020s.js';
import CarouselSwiper from '../services/CarouselSwiper.jsx';
import PageSwiper from '../services/PageSwiper.jsx';
import '../styles/minute.css';
import '../styles/carousel.css';

const Legislation = () => {
    return (
        <div className="justified-text">
            <h5>Other documentation or corroborating evidence</h5>
            <p>
                Bundles of evidence 
            </p>
            <h5>1. 1980's</h5>
            <div>
                <br/>
                <CarouselSwiper images={facts1980s} />
            </div>            
            <h5>2. 1990's</h5>
            <div>
                <br/>
                <CarouselSwiper images={facts1990s} />
            </div>   
            <h5>3. 2000's</h5>
            <div>
                <br/>
                <CarouselSwiper images={facts2000s} />
            </div>   
            <h5>4. 2010's</h5>
            <div>
                <br/>
                <CarouselSwiper images={documents2010s} />
            </div>  
            <h5>5. 2020's</h5>
            <div>
                <br/>
                <PageSwiper images={documents2020s} />
            </div>  
        </div>
    );
};

export default Legislation;

